import phonePrefixes from "@/consts/listPhonePrefixes"

export const DEFAULT_PHONE_PREFIX = "+39"

export function splitPhoneNumber(value = "") {
    const phone = String(value).trim()
    const compactPhone = phone.replace(/\s/g, "")
    const prefix = [...phonePrefixes]
        .sort((left, right) => right.replace(/\s/g, "").length - left.replace(/\s/g, "").length)
        .find(item => compactPhone.startsWith(item.replace(/\s/g, "")))

    let prefixEnd = 0
    let prefixCharacters = prefix?.replace(/\s/g, "").length || 0
    while (prefixCharacters > 0 && prefixEnd < phone.length) {
        if (!/\s/.test(phone[prefixEnd])) prefixCharacters -= 1
        prefixEnd += 1
    }

    return prefix
        ? { prefix, number: phone.slice(prefixEnd).replace(/^[\s-]+/, "") }
        : { prefix: DEFAULT_PHONE_PREFIX, number: phone }
}

export function withFullPhone(contact = {}) {
    const { telephonePrefix, ...fields } = contact
    const telephone = String(fields.telephone || "").trim()

    return {
        ...fields,
        telephone: telephone.startsWith("+") || !telephone
            ? telephone
            : `${telephonePrefix || DEFAULT_PHONE_PREFIX} ${telephone}`
    }
}
